module.exports = __webpack_public_path__ + "598c8fc4a6c7d253078e9f7aa50c6fdc.MP3";